<template>
    <div v-if="reservation">
        <grid ref="grid" class="guest-invoices-grid pt-3" :columnDefs="columnDefs" :rowData="events" :headerHeight="45"
            :paginationPageSize="9" :pagination="true" :isAutoWidth="true" :isAutoHeight="true" :isSearch="false"
            :with-space="false">
            <responsive-dropdown :icon="['fas', 'filter']" :items="logTypeFilter.options" :responsiveness="false"
                variant="primary">
                {{ logTypeFilter.label }}
            </responsive-dropdown>
        </grid>
    </div>
</template>

<script>
import Grid from '../../../../generic/grid/grid.vue';
import { LOG_TYPE_INVOICE, LOG_TYPE_HOUSEKEEPING, LOG_TYPE_MAPPING } from './constants';
import { mapGetters } from 'vuex';
import ResponsiveDropdown from '../../../../generic/responsive-dropdown/responsive-dropdown.vue';
import { escapeHTML } from '../../../../../utils/strings';


export default {
    name: 'GuestInvoicesHistoryTab',
    components: { Grid, ResponsiveDropdown },
    data() {
        return {
            logTypeFilter: {
                label: 'Show All Logs',
                value: null,
                options: [
                    {
                        label: 'Show All Logs',
                        click: () => {
                            this.logTypeFilter.label = 'Show All Logs';
                            this.logTypeFilter.value = null;
                        },
                    },
                    {
                        label: 'Show Invoice Logs',
                        click: () => {
                            this.logTypeFilter.label = 'Show Invoice Logs';
                            this.logTypeFilter.value = LOG_TYPE_INVOICE;
                        },
                    },
                    {
                        label: 'Show Housekeeping Logs',
                        click: () => {
                            this.logTypeFilter.label = 'Show Housekeeping Logs';
                            this.logTypeFilter.value = LOG_TYPE_HOUSEKEEPING;
                        },
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters('guest', ['reservation']),
        columnDefs() {
            return [
                {
                    field: 'type',
                    headerName: 'Type',
                    minWidth: 154,
                    cellRenderer: ({ value }) => {
                        return LOG_TYPE_MAPPING[value];
                    },
                },
                {
                    field: 'date',
                    type: 'dateTimeColumn',
                    headerName: 'Date',
                    minWidth: 250,
                },
                {
                    field: 'event',
                    headerName: 'Event',
                    cellRenderer: ({ data }) => {
                        return !data.url
                            ? `<span>${escapeHTML(data.event)}</span>`
                            : `<span>${escapeHTML(data.event)}</span> 
                        <span>
                            <a target="_blank" href="${data.url}">download</a>
                        </span>`;
                    },
                    autoWidthExclude: !this.isMobile,
                },
            ];
        },
        isMobile() {
            const md = 768;
            return window.innerWidth < md || window.innerHeight < md;
        },
        events() {
            if (this.logTypeFilter.value === LOG_TYPE_INVOICE) {
                return this.reservation.events.filter((event) => event.type === LOG_TYPE_INVOICE);
            } else if (this.logTypeFilter.value === LOG_TYPE_HOUSEKEEPING) {
                return this.reservation.events.filter((event) => event.type === LOG_TYPE_HOUSEKEEPING);
            }
            return this.reservation.events;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../guest-invoices-grid.scss';
</style>
